var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.intentions, function (intention, intentionIndex) {
      return _c(
        "div",
        {
          key:
            _vm.parentContainerId +
            (_vm.parentContainerId ? "-" : "") +
            "xdsl-line-intention-" +
            intentionIndex,
        },
        [
          _c("div", { staticClass: "col-12 px-0 fw-bold" }, [
            _vm._v("\n            " + _vm._s(intention.title) + "\n        "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 px-0" }, [
            _vm._v(
              "\n            " + _vm._s(intention.description) + "\n        "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pt-2 pb-4" },
            [
              _c("generic-button-cta", {
                attrs: {
                  "dto-from-object": intention.genericButtonCta,
                  "css-classes": "btn-secondary",
                },
              }),
            ],
            1
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }